/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of users
 */
export enum UserAccountRoleV2 {
  REGISTERED = 'REGISTERED',
  CUSTOMER = 'CUSTOMER',
  B2B = 'B2B',
  SHOP = 'SHOP',
  BRANDSHOP = 'BRANDSHOP',
}
